import { Text } from "components/common/Text";
import { FC } from "react";

export const LineChart: FC<{
  homeValue: number;
  awayValue: number;
  title: string;
  margin?: string;
  valueFormatter?: (v: number) => string;
  hideTitle?: boolean;
  hideSides?: boolean;
}> = ({
  homeValue,
  awayValue,
  title,
  valueFormatter,
  hideTitle = false,
  hideSides = false,
}) => {
  const total = homeValue + awayValue;
  const progressPct = total > 0 ? (awayValue / total) * 100 : 0;
  return (
    <div className="flex w-full flex-col">
      {!hideTitle && (
        <div className="mb-[0.6vw] w-full text-center font-bold text-statisticTitle">
          <Text variant="chartTitle">{title}</Text>
        </div>
      )}
      <div className="flex w-full items-center justify-center">
        {!hideSides && (
          <span className="flex w-[5vw] items-center justify-center text-right text-white">
            <Text variant="chartValue">
              {valueFormatter ? valueFormatter(homeValue) : homeValue}
            </Text>
          </span>
        )}
        <div className="relative mx-[0.6vw] h-[0.5vw] w-full">
          <div
            className="absolute inset-0 rounded-[5vw]"
            style={{ backgroundColor: "var(--home-color)" }}
          />
          <div
            className="absolute inset-y-0 right-0 rounded-[5vw]"
            style={{
              backgroundColor: "var(--away-color)",
              width: `${progressPct}%`,
            }}
          />
        </div>
        {!hideSides && (
          <span className="flex w-[5vw] items-center justify-center text-left text-white">
            <Text variant="chartValue">
              {valueFormatter ? valueFormatter(awayValue) : awayValue}
            </Text>
          </span>
        )}
      </div>
    </div>
  );
};
